import CityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { happyValleyConfig } from "./data";

export default function HappyValleyPage() {
  return <CityPageTemplate config={happyValleyConfig} />;
}